import { createSelector } from 'reselect';
import { FAI_STATUS } from 'lib/constants';
import { getFAIState } from './getFAIState';

const getFAICurrentInspection = createSelector([getFAIState], (fai) => {
  const inspection = fai?.currentInspection;
  if (!inspection) return null;
  if (
    inspection.status === FAI_STATUS.PENDING ||
    inspection.status === FAI_STATUS.IN_PROGRESS ||
    inspection.status === FAI_STATUS.REJECTED ||
    inspection.status === FAI_STATUS.APPROVED
  ) {
    return inspection;
  }
  return null;
});

export { getFAICurrentInspection };
